import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CartService {
  private cart: any[] = [];
  private totalItems: number = 0;
  private totalQuantity: number = 0;  
    private cartMessageSubject = new BehaviorSubject<string>('');  
  cartMessage$ = this.cartMessageSubject.asObservable();  
  constructor() {
    this.loadCartFromStorage();
  }

  private loadCartFromStorage(): void {
    const savedCart = localStorage.getItem('cart');
    if (savedCart) {
      this.cart = JSON.parse(savedCart);
      this.updateTotals(); // Mettre à jour les totaux après chargement du panier
    }
  }

  private saveCartToStorage(): void {
    localStorage.setItem('cart', JSON.stringify(this.cart));
  }

  // Ajouter un item au panier
  addToCart(item: any): void {
    const existingItem = this.cart.find(cartItem => cartItem.id === item.id);
    if (existingItem) {
      // Le produit est déjà dans le panier, on émet un message
      this.cartMessageSubject.next('Cet article est déjà dans votre panier.');
    } else {
      this.cart.push({ ...item, quantity: 1 });
      this.cartMessageSubject.next('L\'article a été ajouté au panier.');
    }
    this.updateTotals();  // Mettre à jour les totaux après modification
    this.saveCartToStorage();
  }

  // Mise à jour des totaux : totalItems et totalQuantity
  private updateTotals(): void {
    this.totalItems = this.cart.length;  // Nombre de machines distinctes dans le panier
    this.totalQuantity = this.cart.reduce((total, currentItem) => total + currentItem.quantity, 0);  // Total des quantités
  }

  // Supprimer un item du panier
  removeFromCart(itemId: number): void {
    const index = this.cart.findIndex(item => item.id === itemId);
    if (index !== -1) {
      this.cart.splice(index, 1); // Supprimer l'item
      this.updateTotals();  // Mettre à jour les totaux après suppression
      this.saveCartToStorage();
    }
  }

  // Récupérer les items du panier
  getCartItems(): any[] {
    return this.cart;
  }

  // Obtenir le total des items distincts
  getTotalItems(): number {
    return this.totalItems;
  }

  // Obtenir le total des quantités
  getTotalQuantity(): number {
    return this.totalQuantity;
  }

  // Augmenter la quantité d'un item
  increaseQuantity(item: any): void {
    item.quantity++;
    this.updateTotals();  // Mettre à jour les totaux après augmentation
    this.saveCartToStorage();
  }

  // Diminuer la quantité d'un item
  decreaseQuantity(item: any): void {
    if (item.quantity > 1) {
      item.quantity--;
      this.updateTotals();  // Mettre à jour les totaux après diminution
      this.saveCartToStorage();
    }
  }

  // Vider le panier
  clearCart(): void {
    this.cart = [];
    this.totalItems = 0;
    this.totalQuantity = 0;  // Réinitialiser la quantité totale
    localStorage.removeItem('cart');
  }
}
